

export const rnIntroSteps = [
	'Intro',
	'Colors and Images',
	'Ready to start',
];


export const rnAnswers = [
	[
		{color: 'blue', item: 'bike'}, // 1. blå sykkel
		{
			color: 'red',
			item: 'flower',
			language: 'Rødt',
		}, // 2. rødt eple
		{color: 'green', item: 'moon'}, // 3. grønn måne
		{color: 'brown', item: 'cake'}, // 4. brun kake
		{color: 'yellow', item: 'star'}, // 5. gul stjerne
		{color: 'blue', item: 'flower'}, // 6. blå eple
		{color: 'green', item: 'bike'}, // 7. grønn sykkel
		{color: 'red', item: 'star'}, // 8. rød stjerne
		{color: 'brown', item: 'moon'}, // 9. brun måne
		{color: 'yellow', item: 'cake'}, // 10. gul kake
	],
	[
		{color: 'green', item: 'flower'}, // 11. grønt eple
		{color: 'blue', item: 'star'}, // 12. blå stjerne
		{color: 'red', item: 'moon'}, // 13. rød måne
		{color: 'brown', item: 'bike'}, // 14. brun sykkel
		{color: 'yellow', item: 'flower'}, // 15. gult eple
		{color: 'green', item: 'cake'}, // 16. grønn kake
		{color: 'blue', item: 'moon'}, // 17. blå måne
		{color: 'red', item: 'bike'}, // 18. rød sykkel
		{color: 'brown', item: 'flower'}, // 19. brunt eple
		{color: 'yellow', item: 'moon'}, // 20. gul måne
	],
	[
		{color: 'blue', item: 'cake'}, // 21. blå kake
		{color: 'green', item: 'star'}, // 22. grønn stjerne
		{color: 'red', item: 'cake'}, // 23. rød kake
		{color: 'yellow', item: 'bike'}, // 24. gul sykkel
		{color: 'brown', item: 'star'}, // 25. brun stjerne
		{color: 'blue', item: 'moon'}, // 26. blå måne
		{color: 'green', item: 'flower'}, // 27. grønt eple
		{color: 'yellow', item: 'star'}, // 28. gul stjerne
		{color: 'red', item: 'bike'}, // 29. rød sykkel
		{color: 'brown', item: 'cake'}, // 30. brun kake
	],
	[
		{color: 'green', item: 'moon'}, // 31. grønn måne
		{color: 'blue', item: 'bike'}, // 32. blå sykkel
		{color: 'yellow', item: 'flower'}, // 33. gult eple
		{color: 'red', item: 'star'}, // 34. rød stjerne
		{color: 'brown', item: 'moon'}, // 35. brun måne
		{color: 'blue', item: 'cake'}, // 36. blå kake
		{color: 'green', item: 'bike'}, // 37. grønn sykkel
		{color: 'yellow', item: 'moon'}, // 38. gul måne
		{
			color: 'red',
			item: 'flower',
			language: 'Rødt',
		}, // 39. rødt eple
		{color: 'brown', item: 'star'}, // 40. brun stjerne
	],
	[
		{color: 'green', item: 'cake'}, // 41. grønn kake
		{color: 'blue', item: 'star'}, // 42. blå stjerne
		{color: 'yellow', item: 'bike'}, // 43. gul sykkel
		{color: 'red', item: 'moon'}, // 44. rød måne
		{color: 'blue', item: 'flower'}, // 45. blå eple
		{color: 'green', item: 'star'}, // 46. grønn stjerne
		{color: 'yellow', item: 'cake'}, // 47. gul kake
		{color: 'brown', item: 'flower',}, // 48. brunt eple
		{color: 'red', item: 'cake'}, // 49. rød kake
		{color: 'brown', item: 'bike'}, // 50. brun sykkel
	],
];

export const kdrnAnswers = [
	[
		{color: 0, item: 0},
		{color: 1, item: 1},
		{color: 2, item: 2},
		{color: 0, item: 0},
		{color: 1, item: 3},
		{color: 3, item: 4},
	],
	[
		{color: 4, item: 0},
		{color: 2, item: 4},
		{color: 0, item: 2},
		{color: 3, item: 0},
		{color: 3, item: 4},
		{color: 1, item: 3},
	],
	[
		{color: 4, item: 1},
		{color: 1, item: 4},
		{color: 2, item: 2},
		{color: 0, item: 1},
		{color: 0, item: 3},
		{color: 4, item: 0},
	],
	[
		{color: 2, item: 0},
		{color: 1, item: 3},
		{color: 4, item: 2},
		{color: 3, item: 4},
		{color: 0, item: 3},
		{color: 1, item: 2},
		{color: 4, item: 1},
	],
];

export const WMWAnswers = [
	['tjej', 'stol'],
	['hand', 'boll'],
	['pil', 'bär', 'hatt'],
	['buss', 'plåt', 'deg'],
	['väg', 'mål', 'boj', 'kniv'],
	['kopp', 'träd', 'pall', 'mask'],
	['gräs', 'regn', 'mjölk', 'svan', 'tak'],
	['golv', 'säck', 'bok', 'sten', 'grav'],
	['sax', 'häst', 'korv', 'grind', 'sko', 'fisk'],
	['båt', 'får', 'stav', 'hopp', 'grupp', 'hus'],
	['krasch', 'moln', 'blå', 'mark', 'gren', 'vän', 'glass'],
	['svart', 'mås', 'bänk', 'skratt', 'ost', 'hål', 'fot'],
];

export const WMNAnswers = [
	[7, 3],
	[9, 2],
	[8, 5, 1],
	[9, 4, 2],
	[1, 8, 4, 3],
	[3, 7, 2, 6],
	[5, 3, 7, 2, 1],
	[4, 1, 3, 6, 9],
	[1, 9, 5, 2, 7, 8],
	[3, 9, 7, 2, 4, 1],
	[1, 9, 4, 8, 3, 5, 2],
	[2, 7, 4, 1, 7, 9, 6],
];

export const WMNTrialAnswers = [[2, 9]];
export const WMWTrialAnswers = [['sol', 'frö']];

export const SM_adult_trialSentences = ['Regndropparna smattrade mot fönstret medan vinden blåste genom träden.']
export const SM_adult_testSentences = [

'Molnen hopade sig på himlen, och ett kraftigt åskväder var på väg',
'Biblioteket är en populär mötesplats för studenter ',
'Räven, som hade väntat länge, hoppade fram när bytet äntligen dök upp. ',
'Jag ser fram emot semestern, då vi ska resa till en exotisk ö med vita stränder. ',
'Under höstlovet besökte vi en historisk stad där vi lärde oss mycket om medeltidens arkitektur. ',
'Jag gillar att lyssna på poddar om vetenskap och teknik medan jag städar min lägenhet. ',
'På lördag ska vi ordna en middag i grannskapet, där vi kommer att laga spännande maträtter från olika länder. ',
'Han hittade en gammal bok som innehöll handskrivna anteckningar från 1800-talet. ',
'Vi tog en lång promenad längs flodstranden, där vi såg fåglar, fiskar och en bäverdamm.  ',
'På museet såg vi en utställning om rymden som innehöll detaljerade modeller av galaxer och planeter.  ',
'Jag läste en intressant forskningsartikel om hur artificiell intelligens kan förändra arbetsmarknaden. ',
'När vi besökte en gammal katedral fick vi lära oss om gotisk arkitektur och dess historia.',

];

export const nonword_adult_trialWords = [
  'Skjofenal',
];

export const nonword_adult_testWords = [
  'Kjollter ',        // 1
  'Oblömst',       // 2
  'Såmpeltansk',        // 3
  'Pingketargen',    // 4
  'Skjohangor',    // 5
  'Nangotismer',     // 6
  'Kvimpenant',     // 7
  'Stratinskera',    // 8
  'Inkvöstarare',   // 9
  'Agrimmelingst',   // 10
  'Ulterabras',      // 11
  'Numtråtisism',   // 12
];




export const SpoonerismAnswers = [
	
	{ task: 'bok - sång', correct: 'sok - bång' },
  { task: 'paket - ryka', correct: 'raket - pyka' },
  { task: 'fet - lingon', correct: 'let - fingon' },
  { task: 'kran - tång', correct: 'tran - kång' },
  { task: 'kopp - bord', correct: 'bopp - kord' },
  { task: 'sjö - rast', correct: 'rö - sjast' },
  { task: 'haj - koka', correct: 'kaj - hoka' },
  { task: 'gata - blomma', correct: 'bata - glomma' },
  { task: 'salt - bönor', correct: 'balt - sönor' },
  { task: 'kanin - måne', correct: 'manin - kåne' },
  { task: 'potta - kotte', correct: 'kotta - potte' },
  { task: 'leopard - fisk', correct: 'feopard - lisk' },
  { task: 'leka - regna', correct: 'reka - legna' },
  { task: 'lunch - minne', correct: 'munch - linne' },
  { task: 'diska - lejon', correct: 'liska - dejon' },
  { task: 'kung - tjat', correct: 'tjung - kat' }
];

export const SpoonerismIntroTasks = [
	{task: 'bil - löv', correct: 'lil - böv'},
/* 	{task: 'fyra - sex', correct: 'syra - fex'},
	{task: 'sjö - rast', correct: 'rö - sjast'}, */
];

export const phonemeIsolationIntro = [
	{
		id: 0,
		sound: 'g',
		options: {
			a: 'ball',
			b: 'sweater',
			c: 'fish',
			d: 'ski',
		},
		correct: 'b',
	},
	{
		id: 1,
		sound: 'h',
		options: {
			a: 'telephone',
			b: 'flower',
			c: 'motorcycle',
			d: 'house',
		},
		correct: 'd',
	},
];

export const phonemeIsolationTasks = [
	{
		id: 0,
		sound: 'b',
		options: {
			a: 'apple',
			b: 'bicycle',
			c: 'book',
			d: 'tractor',
		},
		correct: 'c',
		type: 'starts_with_',
	},
	{
		id: 1,
		sound: 'k',
		options: {
			a: 'shoe',
			b: 'cat',
			c: 'flower',
			d: 'plane',
		},
		correct: 'b',
		type: 'starts_with_',
	},
	{
		id: 2,
		sound: 'i',
		options: {
			a: 'icecream',
			b: 'chair',
			c: 'baby',
			d: 'horse',
		},
		correct: 'a',
		type: 'starts_with_',
	},
	{
		id: 3,
		sound: 'oe',
		options: {
			a: 'fireengine',
			b: 'ear',
			c: 'cup',
			d: 'teddy',
		},
		correct: 'b',
		type: 'starts_with_',
	},
	{
		id: 4,
		sound: 's',
		options: {
			a: 'jeans',
			b: 'purse',
			c: 'key',
			d: 'bicycle',
		},
		correct: 'd',
		type: 'starts_with_',
	},
	{
		id: 5,
		options: {
			a: 'crocodile',
			b: 'shoe',
			c: 'ski',
			d: 'key',
		},
		correct: 'b',
		sound: 'o',
		type: 'ends_with_',
	},
	{
		id: 6,
		options: {
			a: 'cup',
			b: 'chair',
			c: 'horse',
			d: 'book',
		},
		correct: 'a',
		sound: 'p',
		type: 'ends_with_',
	},
];
export const phonemeIsolationNormingTasks = [
	{
		id: 0,
		sound: 'b',
		options: {
			a: 'apple',
			b: 'bicycle',
			c: 'book',
			d: 'tractor',
		},
		correct: 'book',
		type: 'starts_with_',
	},
	{
		id: 1,
		sound: 'l',
		options: {
			a: 'foot',
			b: 'doll',
			c: 'nose',
			d: 'lion',
		},
		correct: 'lion',
		type: 'starts_with_',
	},
	{
		id: 2,
		sound: 'k',
		options: {
			a: 'shoe',
			b: 'cat',
			c: 'flower',
			d: 'plane',
		},
		correct: 'cat',
		type: 'starts_with_',
	},
	{
		id: 3,
		sound: 'e',
		options: {
			a: 'elephant',
			b: 'spoon',
			c: 'bed',
			d: 'fish',
		},
		correct: 'elephant',
		type: 'starts_with_',
	},
	{
		id: 4,
		sound: 'i',
		options: {
			a: 'horse',
			b: 'chair',
			c: 'baby',
			d: 'icecream',
		},
		correct: 'icecream',
		type: 'starts_with_',
	},
	{
		id: 5,
		sound: 'v',
		options: {
			a: 'rabbit',
			b: 'gloves',
			c: 'tractor',
			d: 'boot',
		},
		correct: 'gloves',
		type: 'starts_with_',
	},
	{
		id: 6,
		sound: 'oe',
		options: {
			a: 'fireengine',
			b: 'ear',
			c: 'cup',
			d: 'teddy',
		},
		correct: 'ear',
		type: 'starts_with_',
	},
	{
		id: 7,
		sound: 's',
		options: {
			a: 'jeans',
			b: 'purse',
			c: 'key',
			d: 'bicycle',
		},
		correct: 'bicycle',
		type: 'starts_with_',
	},
	{
		id: 8,
		sound: 't',
		options: {
			a: 'foot',
			b: 'eye',
			c: 'sun',
			d: 'bed',
		},
		correct: 'foot',
		type: 'ends_with_',
	},
	{
		id: 9,
		options: {
			a: 'crocodile',
			b: 'shoe',
			c: 'ski',
			d: 'key',
		},
		correct: 'shoe',
		sound: 'o',
		type: 'ends_with_',
	},
	{
		id: 10,
		options: {
			a: 'jeans',
			b: 'banana',
			c: 'sweater',
			d: 'saft',
		},
		correct: 'banana',
		sound: 'n',
		type: 'ends_with_',
	},
	{
		id: 11,
		options: {
			a: 'tractor',
			b: 'fish',
			c: 'icecream',
			d: 'cat',
		},
		correct: 'tractor',
		sound: 'r',
		type: 'ends_with_',
	},
	{
		id: 12,
		options: {
			a: 'reflex',
			b: 'plane',
			c: 'book',
			d: 'plowtruck',
		},
		correct: 'plane',
		sound: 'y',
		type: 'ends_with_',
	},
	{
		id: 13,
		options: {
			a: 'chair',
			b: 'cup',
			c: 'horse',
			d: 'book',
		},
		correct: 'cup',
		sound: 'p',
		type: 'ends_with_',
	},
	{
		id: 14,
		options: {
			a: 'bicycle',
			b: 'package',
			c: 'finger',
			d: 'fireengine',
		},
		correct: 'package',
		sound: 'e',
		type: 'ends_with_',
	},
	{
		id: 15,
		options: {a: 'horse', b: 'cup', c: 'porrige', d: 'cow'},
		correct: 'cow',
		sound: 'u',
		type: 'ends_with_',
	},
];

export const oneMinuteTasks = [
	'har',
	'och ',
	'till',
	'den',
	'vill',
	'god',
	'bok',
	'hon',
	'bra',
	'öra',
	'ska',
	'hur',
	'blir',
	'vara ',
	'över',
	'inte',
	'eller',
	'bara',
	'kung',
	'penna ',
	'runt',
	'mellan',
	'kronor',
	'spisen',
	'hjul',
	'göra',
	'skola',
	'svensk',
	'varför',
	'stora',
	'viktig',
	'andra ',
	'flagga',
	'berätta',
	'sig',
	'tidigare',
	'genom',
	'därför',
	'gatsten',
	'samtidig',
	'möjlig',
	'första',
	'fortsatt',
	'varje',
	'alldeles',
	'björn',
	'kjol ',
	'kanske',
	'december',
	'vansklig',
	'linjal',
	'skjorta',
	'kikare',
	'varandra',
	'kölapp',
	'precis',
	'armveck',
	'egentlig',
	'keramik',
	'tiggare',
	'sällskapet',
	'skedde',
	'kyckling',
	'autograf',
	'kista',
	'hjort',
	'kakao',
	'lördag',
	'gjorde',
	'djungel',
	'skäll',
	'utveckling',
	'elefant',
	'ryggsäck',
	'giraff',
	'hjord',
	'gardinerna',
	'leverpastej',
	'rabarber',
	'tuggummi',
	'trampolin',
	'acceptera',
	'proteiner',
	'slickepott',
	'musik',
	'helomvändning',
	'skära',
	'situation',
	'ambivalent',
	'mosaik',
	'erfarenhet',
	'fossil',
	'källsortering',
	'pekfinger',
	'landsförrädare',
	'bilmekaniker',
	'välsigna',
	'perforera',
	'sammansättning',
	'egentligen',
	'spekulation',
	'anklaga',
	'finess',
	'avdramatisera',
	'skärmdump',
	'makulering',
	'garage',
	'ukulele',
	'artär',
	'beredskapsplan',
	'byggindustri',
	'formell',
	'landsbygd',
	'ironisk',
	'utbildningsprogram',
	'beskedligt',
	'varsko',
	'asocial',
	'officiell',
	'hallucination',
	'orubblig',
	'intervention',
	'förbluffad',
	'ointresserad',
	'beivra',
	'flagrant',
	'vaccinera',
	'universell',
	'förskärare',
	'rapsodi',
	'oförsonlig',
	'ordinär',
	'förkrossad',
	'generell',
	'observera',
	'anfäkta',
	'dyskalkyli',
	'opponera',
	'dogmatisk',
	'kulvert',
	'proaktiv',
	'heterogen',
	'preskribera',
	'entré',
	'förtret',
	'illuminerad',
	'irrelevant',
	'desinficera',
	'elicitera',
	'satirisk',
	'konventionell',
	'expedition',
	'paradigm',
	'eklektisk',
	'existentiell',
	'transparent',
	'hegemoni',
	'absorbera',
	'malplacerad',
	'solipsism',
];

export const lkAnswersNorming = [
	'O',
	'O',
	'T',
	'T',
	'W',
	'W',
	'H',
	'H',
	'C',
	'C',
	'E',
	'E',
	'Y',
	'Y',
	'M',
	'M',
	'B',
	'B',
	'Z',
	'Z',
	'Ø',
	'Ø',
	'V',
	'V',
	'K',
	'K',
	'G',
	'G',
	'R',
	'R',
	'S',
	'S',
	'Æ',
	'Æ',
	'F',
	'F',
	'I',
	'I',
	'P',
	'P',
	'J',
	'J',
	'L',
	'L',
	'D',
	'D',
	'N',
	'N',
	'Å',
	'Å',
	'Q',
	'Q',
	'U',
	'U',
	'X',
	'X',
	'A',
	'A',
];
export const lkAnswers = [
	'O',
	'O',
	'E',
	'E',
	'I',
	'I',
	'S',
	'S',
	'T',
	'T',
	'U',
	'U',
	'N',
	'N',
	'Å',
	'Å',
	'G',
	'G',
	'D',
	'D',
	'Æ',
	'Æ',
	'Q',
	'Q',
];
export const kdlkAnswers = [
	'H',
	'H',
	'E',
	'E',
	'M',
	'M',
	'B',
	'B',
	'G',
	'G',
	'R',
	'R',
	'S',
	'S',
	'Æ',
	'Æ',
	'F',
	'F',
	'I',
	'I',
	'J',
	'J',
	'L',
	'L',
	'D',
	'D',
	'N',
	'N',
	'U',
	'U',
];
export const pdIntroSteps = [
	{
		task: 'Kan du säga gris?',
		expectedAnswer: 'gris',
	},
	{
		task: 'Kan du nu säga gris utan /g/',
		expectedAnswer: 'ris',
	},
	{
		task: 'Kan du säga föra?',
		expectedAnswer: 'föra',
	},
	{
		task: 'Kan du nu säga föra utan /f/',
		expectedAnswer: 'öra',
	},
	{
		task: 'Kan du säga len?',
		expectedAnswer: 'len',
	},
	{
		task: 'Kan du nu säga len utan /n/',
		expectedAnswer: 'le',
	},
];
export const pdSteps = [
	'säng',
	'mål',
	'bröd',
	'klass',
	'skägg',
	'trygg',
	'plog',
	'tåg',
	'palm',
	'bro',
	'lampa',
	'spår',
	'loft',
	'läxa',
	'flicka',
	'lok',
];
export const pdAnswers = [
	'äng',
	'ål',
	'röd',
	'lass',
	'ägg',
	'rygg',
	'log',
	'tå',
	'pall',
	'bo',
	'lappa',
	'sår',
	'lott',
	'läcka',
	'ficka',
	'lo',
];

export const wdAnswersNorming = [
	'mase',
	'fly',
	'dra',
	'kråka',
	'melk',
	'tær',
	'rikke',
	'gråt',
	'bake',
	'regne',
	'hyle',
	'takk',
	'hvordan',
	'verden',
	'ekkelt',
	'magisk',
	'ski',
	'leksefri',
	'historier',
	'flokk',
	'senger',
	'kanskje',
	'sjokolade',
	'hjul',
	'rundt',
	'sild',
	'skjelven',
	'godt',
	'kyllinger',
	'kjøtt',
	'smarttelefon',
	'fugl',
	'sykkelhjelm',
	'hjerte',
	'kjeveortoped',
	'blåbærsyltetøy',
	'biblioteket',
	'kjetting',
	'sannsynlighet',
	'abrakadabra',
];

export const wdAnswers = [
	'hvordan',
	'verden',
	'magisk',
	'ski',
	'leksefri',
	'flokk',
	'kanskje',
	'rundt',
	'kyllinger',
	'blåbærsyltetøy',
	'biblioteket',
	'sannsynlighet',
	'abrakadabra',
];
